module.exports = __webpack_public_path__ + "img/card-project1.6857ca8c.jpg";